import Header from '../Component/Header'
import Breadcrumb from "../Component/Breadcrumb";
import Footer from '../Component/Footer'
import LazyLoad from 'react-lazyload';
const SIC = () => {
    return(
        <>      <Header />
            <Breadcrumb title="Administration" mid="Academic &nbsp; &nbsp;|" tabName="Administration" />
            <div className="innerPage">
        <div className="container">
            <div className="row">
                <div className="col-md-12">

                    <h3>ABOUT THE SCHOOL INNOVATION COUNCIL (SIC)</h3>

                    <p>
                        India stands at a defining moment in its educational journey, with one of the largest youth populations
                        in the world. To transform this demographic strength into meaningful progress, education must move
                        beyond memorisation and examinations to cultivate creativity, critical thinking, problem-solving,
                        innovation, and entrepreneurship. Aligned with the vision of the National Education Policy (NEP)
                        2020, the School Innovation Council (SIC) serves as a platform to nurture an innovation-driven
                        mindset among students through ideation, design thinking, research, experimentation, collaboration,
                        and experiential learning. It seeks to connect school education with the broader innovation ecosystem
                        and enable students to explore real-world challenges while developing meaningful solutions for them.
                    </p>

                    <p>
                        At Nirmala Convent School, the School Innovation Council reflects the institution's commitment to
                        holistic education and its motto, Love in Service. Guided by the vision of building a productive,
                        harmonious, just, and humane society and the mission of creating an integral and value-based
                        community, the SIC empowers students to become compassionate innovators and responsible
                        changemakers. As a leading girls' institution, Nirmala is committed to creating opportunities for
                        young women to lead with confidence, think creatively, and contribute meaningfully to society.
                    </p>

                    <p>
                        Through workshops, innovation challenges, exhibitions, mentorship programmes, leadership
                        interactions, and collaborative projects, the Council fosters a culture of curiosity, innovation, and
                        entrepreneurship. By providing every student with a platform to ideate and excel, the SIC strengthens
                        Nirmala's legacy of nurturing future-ready leaders who combine competence with a spirit of service.
                    </p>

                    <h3>ABOUT THE I-CELL</h3>

                    <p>
                        The I-Cell (Innovation Cell) is a dedicated wing of the School Innovation Council (SIC) that
                        promotes a culture of creativity, inquiry, innovation, and research among students. It serves as a
                        platform where young minds can develop solutions to real-world challenges, and transform their
                        creativity into meaningful and practical action. Through innovation-driven activities and
                        collaborative projects, the I-Cell encourages students to think critically, work as excellent team
                        players, and become confident contributors to society.
                    </p>

                    <h3>OUR VISION</h3>

                    <p>
                        To nurture creative, empathetic, and inspired young women who lead with confidence, embrace
                        lifelong learning, and contribute meaningfully to society through effective application of innovative
                        ideas.
                    </p>

                    <h3>OBJECTIVES OF THE I-CELL</h3>

                    <ul className='list-view'>
                        <li>Foster a culture of ideation and problem-solving among students.</li>
                        <li>Encourage curiosity and scientific inquiry through research-based learning.</li>
                        <li>Develop analytical, critical thinking, design thinking, and computational skills.</li>
                        <li>Provide opportunities for students to explore emerging technologies.</li>
                        <li>Create platforms for students to showcase and apply their ideas, innovations, and talents.</li>
                        <li>
                            Promote collaboration with educational institutions, experts, and industry professionals to
                            enrich learning experiences.
                        </li>
                        <li>
                            Empower girls to take leadership roles in innovation, research, and community-focused
                            initiatives.
                        </li>
                    </ul>

                    <h3>EXPECTED OUTCOMES OF THE I-CELL</h3>

                    <ul className='list-view'>
                        <li>
                            A vibrant innovation ecosystem that encourages ideation, experimentation, and continuous
                            learning.
                        </li>
                        <li>Enhanced problem-solving and leadership capabilities among students.</li>
                        <li>
                            Greater confidence among girls to pursue opportunities in science, technology, innovation,
                            and social entrepreneurship.
                        </li>
                        <li>Improved readiness for higher education, research, and future career pathways.</li>
                        <li>
                            Development of socially responsible innovators who apply their knowledge and skills in
                            service of the community and society.
                        </li>
                    </ul>

                    <h3>ABOUT THE ENTREPRENEURSHIP CELL (E-CELL)</h3>

                    <p>
                        The Entrepreneurship Cell (E-Cell) of the School Innovation Council (SIC) is dedicated to fostering
                        entrepreneurial thinking and business awareness among students. While the Innovation Cell majorly
                        focuses on ideation and innovation, the E-Cell enables students to explore how ideas can be
                        transformed into viable ventures, social enterprises, and sustainable solutions through practical
                        action.
                    </p>

                    <p>
                        The Cell provides opportunities for students to develop an understanding of entrepreneurship,
                        financial literacy, market research, enterprise development, and Intellectual Property (IP) rights.
                        Through workshops, competitions, mentorship programmes, industry interactions, and case studies,
                        students gain practical exposure to the skills and mindset required to succeed in a rapidly evolving
                        world.
                    </p>

                    <p>
                        Aligned with Nirmala's commitment to holistic education and service, the E-Cell empowers young
                        women to become confident leaders and changemakers who create value for society.
                    </p>

                    <h3>OUR VISION</h3>

                    <p>
                        To nurture entrepreneurial thinking and create leaders who possess the confidence, competence, and
                        values to transform ideas into impactful ventures.
                    </p>

                    <h3>OBJECTIVES OF THE E-CELL</h3>

                    <ul className='list-view'>
                        <li>Cultivate an entrepreneurial mindset and business awareness among students.</li>
                        <li>Introduce students to the fundamentals of start-up culture and enterprise development.</li>
                        <li>Develop financial literacy, negotiation, communication, and decision-making skills.</li>
                        <li>
                            Encourage students to transform innovative ideas into viable business and social enterprise
                            models.
                        </li>
                        <li>
                            Foster networking opportunities with entrepreneurs, professionals, and higher educational
                            institutions through mentorship, workshops, competitions, and industry interactions.
                        </li>
                        <li>
                            Promote ethical entrepreneurship aligned with social responsibility and community
                            development.
                        </li>
                    </ul>

                    <h3>EXPECTED OUTCOMES OF THE E-CELL</h3>

                    <ul className='list-view'>
                        <li>Increased entrepreneurial awareness and business readiness among students.</li>
                        <li>Enhanced leadership, financial, managerial, and strategic thinking skills.</li>
                        <li>Development of viable business concepts and start-up ideas.</li>
                        <li>
                            Stronger engagement with the business ecosystem through collaborations and mentorship.
                        </li>
                        <li>
                            A generation of responsible young women entrepreneurs who create value through
                            innovation, integrity, and service.
                        </li>
                    </ul>

                </div>
            </div>
        </div>
    </div>
            <Footer />
        </>
    )
}
export default SIC;